module.exports = __webpack_public_path__ + "static/media/salt-in-white-surface-3693296.aa4209e6.jpg";